import React from 'react';
import { useForm } from 'react-hook-form';
import type { Settings } from '../types/course';

interface SettingsFormProps {
  settings: Settings;
  onUpdate: (settings: Settings) => Promise<void>;
}

export function SettingsForm({ settings, onUpdate }: SettingsFormProps) {
  const { register, handleSubmit } = useForm({
    defaultValues: {
      pageTitle: settings.pageTitle || '',
      logo: settings.logo || '',
      favicon: settings.favicon || '',
      categoriesString: (settings.categories || []).join(', '),
      tagsString: (settings.tags || []).join(', '),
      htmlContent: settings.htmlContent || ''
    }
  });

  const onSubmit = (data: any) => {
    onUpdate({
      ...settings,
      pageTitle: data.pageTitle,
      logo: data.logo,
      favicon: data.favicon,
      categories: data.categoriesString.split(',').map((cat: string) => cat.trim()).filter(Boolean),
      tags: data.tagsString.split(',').map((tag: string) => tag.trim()).filter(Boolean),
      htmlContent: data.htmlContent
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <h3 className="text-xl font-semibold mb-4">Paramètres généraux</h3>
      
      <div>
        <label className="block text-sm font-medium mb-2">Titre de la page</label>
        <input
          {...register('pageTitle')}
          type="text"
          className="w-full p-2 border rounded"
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">Logo URL</label>
        <input
          {...register('logo')}
          type="text"
          className="w-full p-2 border rounded"
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">Favicon URL (format .ico, .png ou .svg)</label>
        <input
          {...register('favicon')}
          type="text"
          className="w-full p-2 border rounded"
          placeholder="https://example.com/favicon.ico"
        />
        <p className="mt-1 text-sm text-gray-500">
          L'image doit être carrée, idéalement 32x32 ou 64x64 pixels
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">Catégories (séparées par des virgules)</label>
        <input
          {...register('categoriesString')}
          type="text"
          className="w-full p-2 border rounded"
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">Tags disponibles (séparés par des virgules)</label>
        <input
          {...register('tagsString')}
          type="text"
          className="w-full p-2 border rounded"
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">Contenu HTML personnalisé</label>
        <textarea
          {...register('htmlContent')}
          className="w-full p-2 border rounded font-mono"
          rows={10}
        />
      </div>

      <button type="submit" className="btn">
        Sauvegarder les paramètres
      </button>
    </form>
  );
}